import Vue from "vue";
import { mapMutations } from "vuex";
import portal from "@vacancorp/portal";
import { PortalAdapterApi } from "@vacancorp/portal.adapter.api";

export default Vue.extend({
  name: "mixin-split-view",
  props: {
    isGMapInAction: Boolean,
  },
  data() {
    return {
      pagerOfPlaceListOnCards: 1,
      showPlaceCategoryList: false,
    };
  },
  computed: {
    $showTopAreaList(): boolean {
      return this.$store.state.ui.showTopAreaList;
    },
    $menuPanelShown(): boolean {
      return this.$store.state.ui.menuPanelShown;
    },
    $showLoadingCard(): boolean {
      return this.$store.state.ui.showLoadingCard;
    },
    $alertBar(): {
      status: boolean;
      title: string;
      subtitle: string;
    } {
      return this.$store.state.ui.alertBar;
    },
    $isFirstLoadMap(): boolean | undefined {
      return this.$store.state.data.isFirstLoadMap;
    },
    $selectedGenre(): PortalAdapterApi.PlaceCategoryType | undefined {
      return this.$store.state.data.selectedGenre;
    },
    $selectedTopPlace(): PortalAdapterApi.TopArea {
      return this.$store.state.data.selectedTopPlace;
    },
  },
  methods: {
    ...mapMutations("ui", ["showMenuPanel", "setShowTopAreaList"]),
    openMenu() {
      // GA, GTM tracking
      this.$gtag.event("click", {
        event_category: "Map item",
        event_label: "Menu avatar button",
        value: 1,
      });
      this.showMenuPanel(true);
    },
    closeMenu() {
      this.showMenuPanel(false);
    },
    showThroneCard(place: portal.PublicPlaceWithVacancyId): boolean {
      if (place?.genre === undefined) return false;
      return place?.genre.type === "toilet";
    },
  },
});
